import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import Iframe from "react-iframe";
import { confirmAlert } from "react-confirm-alert";
import { fetchTemplate } from "SettingActions";
import { showSuccess } from "ReduxErrorBar";
import { GRAPESJE_EDITOR } from "Constants";
import Loader from "Loader";
import LocaleStrings from "Languages";
import NewemailEditor from "./email-editor";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

class GrapesEdit extends Component {
  constructor(props) {
    super(props);
    var greapeseditor = GRAPESJE_EDITOR;
    this.state = {
      greapeseditor,
      loading: true,
      desc: "Editor Loading",
      btnLoading: false,
    };
  }

  hideSpinner = () => {
    this.setState({
      loading: false,
    });
  };

  closeModals = () => {
    // this.props.fetchTemplate(this.props.session);
    confirmAlert({
      // title: 'Saved Template',
      message: LocaleStrings.setting_email_template_update_confirm_subtitle,
      buttons: [
        {
          label: LocaleStrings.button_close,
          onClick: () => {
            this.props.onClose();
          },
        },
        {
          label: LocaleStrings.button_continue_editing,
          onClick: () => {},
        },
      ],
    });
  };

  callIframesave = () => {
    // this.setState({btnLoading:true})
    // console.log('hi');
    document.getElementById("myId").contentWindow.myFunction();
    this.props.actions.showSuccess(LocaleStrings.template_updated_message);
    // this.setState({ btnLoading: false });
    // this.props.fetchTemplate(this.props.session, (callback) => {

    //   // this.props.onClose();
    // });
  };

  render() {
    let { session, pageid, section, deviceSize } = this.props;
    // console.log("deviceSize :- ", deviceSize);

    return (
      <Modal
        show={this.props.isOpen}
        onHide={this.closeModals}
        className="modal-container custom-full-screen-modal"
        dialogClassName="modal-xl">
        <Modal.Header>
          <Modal.Title>
            <div className="title-modal">
              {LocaleStrings.setting_email_template_update_modal_title}
            </div>
          </Modal.Title>
          <button
            type="button"
            className="i-custom-cross-popup pull-right"
            onClick={this.closeModals}>
            <img
              className="i-custom-small"
              src="../../style/images/custom-icons/cross-black.png"
            />
          </button>
        </Modal.Header>
        <Modal.Body>
          {this.state.loading ? (
            <div className="loader-container">
              <Loader />
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : null}
          <div className="" style={{ height: "700px" }}>
            <Iframe
              // url={`${this.state.greapeseditor}?pageid=${pageid}&apikey=${session.apiKey}&session_token=${session.sessionToken}&section=${section}`}
              url={`${this.state.greapeseditor}?pageid=${pageid}&apikey=${session.apiKey}&session_token=${session.sessionToken}&section=${section}&eventid=${session.eventid}`}
              width="100%"
              height={`${deviceSize.height - 200}px`}
              id="myId"
              className="myClassname"
              display="initial"
              position="relative"
              onLoad={this.hideSpinner}
            />

            {/* <NewemailEditor /> */}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.closeModals}>
            {LocaleStrings.button_close}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    deviceSize: state.deviceSize,
  };
}
export default connect(mapStateToProps, {
  fetchTemplate,
  showSuccess,
})(GrapesEdit);
